(function ($) {
  DJ.addBehavior('headerAccountMenu', '.js-header-account-menu', {
    attach: function () {
      const container = this;
      const dropDownBtn = container.querySelector('.header-account-menu__btn');
      const dropDown = container.querySelector('.header-account-menu__dropdown');
      const openClass = 'header-account-menu__dropdown--open';
      const btnClass = 'header-account-menu__btn--active';
      let isOpen = false;

      /**
       * Add/remove open class for dropdown and active class for button.
       * @param dropdown
       *    dropdown selector.
       * @param btn
       *    button selector.
       */
      const toggleDropDown = (dropdown, btn) => {
        isOpen = !isOpen;
        dropdown.classList.toggle(openClass);
        btn.classList.toggle(btnClass);
        btn.setAttribute('aria-expanded', isOpen);
      };

      /**
       * Clear body click.
       */
      const clearBodyClick = () => {
        $('body').off('click.bodyHeaderAccountDropdownClose');
      };

      /**
       * Close dropdown on body click.
       */
      const onBodyClick = () => {
        $('body').on('click.bodyHeaderAccountDropdownClose', (e) => {
          if (!($(e.target).closest('.header-account-menu__dropdown').length)) {
            toggleDropDown(dropDown, dropDownBtn);
            clearBodyClick();
          }
        });
      };

      /**
       * Open/close dropdown on button click.
       */
      if (dropDownBtn && dropDown) {
        dropDownBtn.addEventListener('click', () => {
          toggleDropDown(dropDown, dropDownBtn);

          if (dropDown.classList.contains(openClass)) {
            const bodyTimer = setTimeout(() => {
              onBodyClick();
              clearTimeout(bodyTimer);
            }, 50);
          } else {
            clearBodyClick();
          }
        });
      }
    }
  });
})(jQuery);
